module.exports = __webpack_public_path__ + "img/inter210.ba366436.jpg";